{
  "name": "esci-tools",
  "version": "26.10.29-1",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --configuration production",
    "test": "vitest run --coverage",
    "test-local": "vitest run --coverage",
    "lint": "ng lint",
    "gm-install": "npm ci",
    "gm-build": "ng build --configuration aks",
    "gm-test": "vitest run --coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^21.2.1",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@primeuix/themes": "^2.0.3",
    "ag-grid-angular": "^31.0.3",
    "ag-grid-community": "^31.0.3",
    "angular-oauth2-oidc": "^20.0.0",
    "dom-to-image": "^2.6.0",
    "exceljs": "^4.4.0",
    "font-awesome": "^4.7.0",
    "jszip": "^3.10.1",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.3",
    "quill": "^2.0.3",
    "rxjs": "^7.8.1",
    "tslib": "^2.6.2",
    "xlsx": "^0.20.2",
    "zone.js": "~0.15.1"
  },
  "overrides": {
    "@peculiar/asn1-x509-attr": "2.8.0",
    "js-yaml": "4.3.2",
    "brace-expansion@1": "1.1.21",
    "brace-expansion@2": "2.1.7",
    "brace-expansion@5": "5.0.12",
    "fast-uri": "3.1.8",
    "source-map-js": "1.2.2",
    "compression": "1.8.2",
    "proxy-addr": "2.0.8",
    "form-data": "4.0.6",
    "ws": "8.22.0",
    "tmp": "0.2.7",
    "lodash-es": "4.18.1",
    "launch-editor": "2.14.2",
    "zod": "4.6.6"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.3.1",
    "@analogjs/vitest-angular": "^2.3.1",
    "@angular-devkit/build-angular": "^21.2.25",
    "@angular-eslint/builder": "^21.3.0",
    "@angular-eslint/eslint-plugin": "^21.3.0",
    "@angular-eslint/eslint-plugin-template": "^21.3.0",
    "@angular-eslint/schematics": "^21.3.0",
    "@angular-eslint/template-parser": "^21.3.0",
    "@angular/build": "^21.2.25",
    "@angular/cli": "^21.2.27",
    "@angular/compiler-cli": "^21.2.25",
    "@angular/language-service": "^21.2.25",
    "@tailwindcss/postcss": "^4.2.2",
    "@types/node": "^22.19.15",
    "@typescript-eslint/eslint-plugin": "8.58.0",
    "@typescript-eslint/parser": "8.58.0",
    "@vitest/coverage-v8": "4.1.10",
    "eslint": "^8.57.0",
    "jsdom": "^22.0.0",
    "less": "^4.2.0",
    "postcss": "^8.5.8",
    "tailwindcss": "^4.2.1",
    "typescript": "^5.9.3",
    "vite": "^7.0.0",
    "vite-tsconfig-paths": "^4.2.0",
    "vitest": "4.1.10"
  }
}
